var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "app" } }, [
    _c(
      "div",
      { staticClass: "catalog-container" },
      [
        _c(
          "b-alert",
          {
            staticClass: "unpublished-container",
            attrs: { show: !_vm.catalogueActive, variant: "secondary" },
          },
          [
            _vm._v(
              "\n      This catalogue is currently unpublished and not visible to users.\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _vm.displayFilters
          ? _c(
              "div",
              { staticClass: "filter-container" },
              [
                _c("noscript", [
                  _vm._v(
                    "Filtering options are only available if javascript is enabled."
                  ),
                ]),
                _vm._v(" "),
                _c("no-ssr", [
                  _c(
                    "div",
                    {
                      staticClass: "filter-header",
                      class: { expanded: _vm.isActive },
                      on: {
                        click: function ($event) {
                          _vm.isActive = !_vm.isActive
                        },
                      },
                    },
                    [
                      _c("h3", [
                        !_vm.isActive ? _c("span", [_vm._v("Show")]) : _vm._e(),
                        _vm._v(" "),
                        _vm.isActive ? _c("span", [_vm._v("Hide")]) : _vm._e(),
                        _vm._v(" Filters\n          "),
                      ]),
                      _vm._v(" "),
                      _c("catalog-svg-icons", {
                        attrs: { name: "ChevronIcon" },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("no-ssr", [
                  _c(
                    "div",
                    {
                      staticClass: "filter-region-content",
                      class: { "showing-mobile-filters": _vm.isActive },
                    },
                    [
                      _c("div", { staticClass: "filter-region-title" }, [
                        _c("h3", [_vm._v("Refine by")]),
                      ]),
                      _vm._v(" "),
                      _c("filter-panel-view", {
                        attrs: { filters: _vm.filters, products: _vm.products },
                        model: {
                          value: _vm.filterValues,
                          callback: function ($$v) {
                            _vm.filterValues = $$v
                          },
                          expression: "filterValues",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "main-container" }, [
          _c(
            "div",
            { staticClass: "sorting-container" },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("noscript", [
                        _vm._v(
                          "Sorting options are only available if javascript is enabled."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("no-ssr", [
                        _c(
                          "div",
                          { staticClass: "top-filters" },
                          [
                            _c("sorting", {
                              attrs: { sorters: _vm.sorters },
                              model: {
                                value: _vm.sorting,
                                callback: function ($$v) {
                                  _vm.sorting = $$v
                                },
                                expression: "sorting",
                              },
                            }),
                            _vm._v(" "),
                            _c("view-toggle", {
                              model: {
                                value: _vm.view,
                                callback: function ($$v) {
                                  _vm.view = $$v
                                },
                                expression: "view",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "product-container" },
            [
              _c(_vm.view, {
                tag: "component",
                class: _vm.cardTheme,
                attrs: { items: _vm.catalogueData },
              }),
            ],
            1
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }